import React, { forwardRef } from "react";
import classNames from "classnames";
import { ODSToastProps } from "./ODSToast.types";
import { ODSNotification } from "../ODSNotification";
import "./css/index.css";

const ODSToast = forwardRef<HTMLDivElement, ODSToastProps>(
  ({ className, ...props }, ref) => {
    return (
      <ODSNotification
        ref={ref}
        variant="toast"
        aria-live="assertive"
        aria-atomic
        className={classNames("ODSToast", className)}
        {...props}
      ></ODSNotification>
    );
  }
);

ODSToast.displayName = "ODSToast";

export default ODSToast;
